module.exports = __webpack_public_path__ + "static/img/android-chrome-144x144.862be40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/android-chrome-144x144.png
// module id = 554
// module chunks = 1